<template>
    <div v-cloak>
        <load-spinner :loading="isLoading" />
        <b-table
            show-empty
            :items="competencies"
            :fields="competency_fields[mode]"
            :class="'table-responsive'"
            stacked="md"
            bordered
        >
            <template
                v-slot:cell(kap_task)="row"
            >
                <span :key="`${row.item.id}-kap-task-traffic-light`">
                    <!-- Check for assess tool existing -->
                    <b-button
                        v-if="assessmentToolViewable(row.item) && ['ATT', 'PO', 'COM'].includes(row.item.result)"
                        size="sm"
                    >
                        <!-- Set traffic light colour of circle -->
                        <i
                            class="fas fa-circle"
                            :class="getTrafficLight(row.item.assessment_tool_linkable ? row.item.assessment_tool_linkable.practical_task_status : null)"
                        />
                    </b-button>
                </span>
            </template>
            <template
                v-slot:cell(code_title)="row"
            >
                <span>
                    <b>{{ row.item.code }} -</b> {{ row.item.title }}
                </span>
            </template>
            <template
                v-slot:cell(code)="row"
            >
                <span v-if="hyperlinks && hyperlinks[row.item.code.toUpperCase()] && row.item.level <= getLevel(student.level)">
                    <a
                        :href="hyperlinks[row.item.code.toUpperCase()]"
                        :title="`Open ${row.item.code} in Moodle!`"
                        target="_blank"
                    >
                        <img height='16px' src="/images/moodle.svg"> {{ row.item.code }}
                    </a>
                </span>
                <span v-else>
                    {{ row.item.code }}
                </span>
            </template>

            <!-- <template
                slot="delivery_type"
                slot-scope="row"
            >
                <delivery-type-bulk
                    :enrolment-id="Number(row.item.id)"
                    :code="row.item.code"
                    :old-value="Number(row.item.delivery_type)"
                    :read-only="true"
                    field-name="DeliveryType"
                    description="Delivery conducted by RTO/WBD"
                    @refreshData="refreshData"
                />
            </template> -->

            <template
                :id="'entp_assessment_methods' + row.item.id"
                v-slot:cell(entp_assessment_methods)="row"
            >
                {{ row.item.entp_assessment_methods }}
            </template>

            <template
                v-slot:cell(proposed_start_date)="row"
            >
                {{ row.item.proposed_start_date | formatDate }}
            </template>

            <template
                v-slot:cell(proposed_end_date)="row"
            >
                {{ row.item.proposed_end_date | formatDate }}
            </template>

            <template
                v-slot:cell(result)="row"
            >
                {{ row.item.result === 'COM' ? 'CA' : row.item.result }}
            </template>

            <template
                v-slot:cell(result_start_date)="row"
            >
                {{ row.item.result_start_date | formatDate }}
            </template>

            <template
                v-slot:cell(rto_sign_off_allowed)="row"
            >
                {{ row.item.rto_sign_off_allowed == '2' ? 'NO' : 'YES' }}
            </template>

            <template
                v-slot:cell(result_end_date)="row"
            >
                <span v-if="row.item.result != 'ATT'">
                    {{ row.item.result_end_date | formatDate }}
                </span>
            </template>

            <template
                v-slot:cell(employer_support_of_competence)="row"
            >
                <div v-if="row.item.employer_support_of_competence == 1">
                YES
                </div>
                <div v-else>
                NO
                </div>
            </template>

            <template
                v-slot:cell(academic_period)="row"
            >
                {{ row.item.academic_period }}
            </template>

            <template
                v-slot:cell(itp_delivery_type)="row"
            >
                <div v-if="row.item.itp_delivery == 1">
                    Online
                </div>
                <div v-else-if="row.item.itp_deivery_type == 2">
                    Face to Face
                </div>
                <div v-else-if="row.item.itp_delivery_type == 3">
                    Mixed
                </div>
            </template>

            <template
                v-slot:cell(action)="row"
            >
                <b-button
                    size="sm"
                    @click.stop="showElements(row)"
                >
                    <i :class="[row.detailsShowing && !row.item._showAttachments ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down', 'fas']" /> Elements
                    <b-badge variant="light">
                        {{ elements(row.item.code).length }}
                    </b-badge>
                </b-button>
            </template>

            <template
                v-slot:cell(evidence)="row"
            >
                <b-button
                    size="sm"
                    @click.stop="showAttachments(row)"
                >
                    <span v-if="showEvidenceTrafficLight" :key="`${row.item.id}-evidence-traffic-light`">
                        <i
                            class="fas fa-circle"
                            :class="getEvidenceTrafficLight(row.item.enrolment_attachments)"
                        /> Evidence
                        <b-badge variant="light">
                            {{ row.item.enrolment_attachments ? row.item.enrolment_attachments.length : 0 }}
                        </b-badge>
                    </span>
                </b-button>
            </template>
            
            <template
                #row-details="row"
            >
                <part-one-element-component
                    v-if="!row.item._showAttachments"
                    :enrolment-id="Number(row.item.id)"
                    :elements="elements(row.item.code)"
                    :code="row.item.code"
                    :competency-result="row.item.result"
                    @refreshData="refreshData"
                    @updateElement="shouldAddNote"
                />
                <div v-else>
                    <enrolment-attachments
                        :enrolment="row.item"
                    />
                </div>
            </template>
            <template
                v-slot:cell(signoff)="row"
            >
                <b-button
                    v-if="assessmentToolViewable(row.item)"
                    size="sm"
                    :href="`/assessment-tool/observation-report/${row.item.id}`"
                >
                    <!-- Set traffic light colour of circle -->
                    <span :key="`${row.item.id}-signoff-traffic-light`">
                        <i
                            class="fas fa-circle"
                            :class="getSignoffTrafficLight(row.item.assessment_tool_linkable ? row.item.assessment_tool_linkable.supervisor_student_signoff_student_signed : null)"
                        /> Signoff
                    </span>
                </b-button>
            </template>
            <template
                v-slot:cell(finalrecord)="row"
            >
                <b-button
                    v-if="assessmentToolViewable(row.item)"
                    size="sm"
                    :href="`/assessment-tool/final-record/${row.item.id}`"
                >
                    <!-- Set traffic light colour of circle -->
                    <span :key="`${row.item.id}-final-record-traffic-light`">
                        <i
                            class="fas fa-circle"
                            :class="getSignoffTrafficLight(row.item.assessment_tool_linkable ? row.item.assessment_tool_linkable.final_record_student_signed : null)"
                        /> Final Record
                    </span>
                </b-button>
            </template>
        </b-table>

        <student-signature-component
            :student="student"
            @refreshData="refreshData"
        />

        <part-one-bottom-component
            :student="student"
            :enrolment-details="enrolmentDetails"
            :total-hours="totalHours"
            @refreshData="refreshData"
        />

        <b-modal
            ref="noteModal"
            title="Add Note"
            @ok="updateResult(updates.enrolment, updates.result)"
            @cancel="updateResult(updates.enrolment, updates.result)"
        >
            <b-form-textarea
                v-model="updates.note"
                placeholder="Add note"
                :rows="3"
            />
        </b-modal>
    </div>
</template>

<script>
/* global axios */
/* global Noty */
/* global _ */
import ProposedDateBulk from './ProposedDateBulk.vue';
import EnrolmentDateComponent from './EnrolmentDateComponent.vue';
import DeliveryTypeBulk from './DeliveryTypeBulk.vue';
import PersonResponsibleBulk from './PersonResponsibleBulk.vue';
import PartOneBottomComponent from './PartOneBottomComponent.vue';
import PartOneElementComponent from './PartOneElementComponent.vue';
import StudentSignatureComponent from './StudentSignatureComponent.vue';
import EnrolmentAttachments from '../EnrolmentAttachments.vue';

export default {
    name: 'LevelPartOne',
    components: {
        ProposedDateBulk,
        DeliveryTypeBulk,
        PersonResponsibleBulk,
        PartOneElementComponent,
        PartOneBottomComponent,
        EnrolmentDateComponent,
        StudentSignatureComponent,
        EnrolmentAttachments
    },
    props: {
        competencies: {
            type: Array,
            required: true,
        },
        enrolments: {
            type: Array,
            required: true,
        },
        enrolmentDetails: {
            type: Object,
            required: false,
            default: () => {},
        },
        teachers: {
            type: Array,
            required: true,
        },
        student: {
            type: Object,
            required: true,
        },
        hyperlinks: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            competency_fields: {
                compliance: [
                    { key: 'kap_task' },
                    { key: 'code', label: 'Unit Code', class: 'nowrap' },
                    { key: 'title', label: 'Unit Title' },
                    { key: 'hours', label: 'SC Hrs' },
                    ...(this.student.state != 'NSW' ? [{ key: 'delivery_type', label: 'Delivery conducted by RTO/WBD' }] : []),
                    ...(this.student.qualification_details.course_type == 'Non-Apprenticeship' ? [{ key: 'itp_delivery_type', label: 'ITP Delivery Type'}] : []),
                    ...(this.student.state == 'NSW' ? [{ key: 'responsibility_for_training', label: 'Responsibility For Training'}] : []),
                    { key: 'entp_assessment_methods', label: 'Assessment Methods' },
                    { key: 'proposed_start_date' },
                    { key: 'proposed_end_date' },
                    { key: 'result', label: 'Outcome' },
                    { key: 'result_start_date', label: 'Actual Start Date' },
                    { key: 'result_end_date', label: 'Actual End Date' },
                    { key: 'rto_sign_off_allowed', label: 'RTO sign-off allowed' },
                    ...(this.student.state == 'QLD' ? [{ key: 'employer_support_of_competence', label: 'Employer Support of Competence' }] : []),
                    ...(this.student.qualification_details.course_type == 'Non-Apprenticeship' ? [{ key: 'academic_period', label: 'Academic Period'}] : []),
                    // { key: 'attachments' },
                    { key: 'evidence' },
                    { key: 'signoff' },
                    { key: 'finalrecord', label: 'Final Record' }
                ],
            },
            resultOpts: [
                'RPL',
                'CT',
                'ATT',
                'PO',
                'COM',
            ],
            currentRowDetails: '',
            mode: 'compliance',
            modes: [
                {
                    text: 'Compliance Mode',
                    value: 'compliance',
                },
            ],
            updates: {
                note: '',
                enrolment: {},
                result: '',
            },
            isLoading: false,
            showEvidenceTrafficLight: true,
        };
    },
    validations: {},
    computed: {
        level() {
            return Number(this.$route.path.split('/')[3].slice(-1));
        },
        totalHours() {
            return this.competencies.reduce((prev, cur) => Number(prev) + Number(cur.hours), 0);
        },
        totalY() {
            return this.competencies.filter(enrolment => Number(enrolment.delivery_type) === 1).length;
        },
        totalN() {
            return this.competencies.filter(enrolment => Number(enrolment.delivery_type) === 2).length;
        },
        totalNA() {
            return this.competencies.filter(enrolment => Number(enrolment.delivery_type) === 3).length;
        },
    },
    watch: {
        mode() {
            sessionStorage.setItem('levelMode', this.mode);
        },
        enrolments() {
            if (this.currentRowDetails !== '') {
                // open the elements
                const found = this.competencies.find(el => el.id.toString() === this.currentRowDetails);
                if (!_.isUndefined(found) && found !== -1) {
                    /* eslint-disable-next-line */
                    found._showDetails = true;
                }
                this.currentRowDetails = '';
            }
        },
    },
    mounted() {
        const oldMode = sessionStorage.getItem('levelMode');
        if (oldMode) {
            this.mode = oldMode;
        }
    },
    filters: {
        formatDate(date) {
            if (moment(date).isValid()) {
                return moment(date).format('DD/MM/YYYY');
            }
            return '';
        },
    },
    methods: {
        pluck(array, key) {
            return array.map(o => o[key]);
        },
        getTrafficLight(status) {
            if (!_.isUndefined(status) && !_.isNull(status)) {
                switch (status) {
                case '1':
                    return 'text-yellow';
                case '2':
                    return 'text-green';
                default:
                    return 'text-red';
                }
            }
            return 'text-red';
        },
        getSignoffTrafficLight(signed) {
            if (signed && signed == true) {
                return 'text-green';
            }
            return 'text-red';
        },
        getEvidenceTrafficLight(evidenceArray) {
            if (!_.isUndefined(evidenceArray) && !_.isNull(evidenceArray) && evidenceArray.length > 0) {
                return 'text-green';
            }
            return 'text-red';
        },
        getLevel(level) {
            let current_level = 0;
            switch (level) {
                case 'Cluster 1':
                case 'Level 1':
                    current_level = 1;
                    break;
                case 'Cluster 2':
                case 'Level 2':
                    current_level = 2;
                    break;
                case 'Cluster 3':
                case 'Level 3':
                    current_level = 3;
                    break;
                case 'Cluster 4':
                case 'Level 4':
                    current_level = 4;
                    break;
                case 'Pipeline':
                default:
                    current_level = 5;
                    break;
            }
            return current_level;
        },
        getOptions(options, currentResult) {
            // find index of currentResult if set
            if (currentResult === 'CT' || currentResult === 'RPL') {
                return [];
            }
            if (currentResult !== '') {
                const index = options.indexOf(currentResult);
                if (index !== -1) {
                    return options.slice(index + 1);
                }
            }
            return options;
        },
        encode(str) {
            return btoa(str.toString()).replace(/\+/g, '.').replace(/=/g, '-').replace(/\//g, '~');
        },
        refreshData(id = null) {
            this.currentRowDetails = id;
            this.$emit('refreshData');
        },
        deliveryCompletion(deliveryType) {
            switch (Number(deliveryType)) {
            case 1:
                return 'YES';
            case 2:
                return 'NO';
            default:
                return '';
            }
        },
        elements(code) {
            return this.enrolments.filter(enrolment => enrolment.code === code && enrolment.element_code !== code);
        },
        shouldAddNote(enrolment, selectedResult) {
            // check if the user wants to add a note
            const q = new Noty({
                layout: 'center',
                text: 'Would you like to add a note?',
                timeout: false,
                modal: true,
                buttons: [
                    Noty.button('YES', 'btn btn-success', () => {
                        this.updates.note = '';
                        this.updates.enrolment = enrolment;
                        this.updates.result = selectedResult;
                        // call another function here to show a proper modal
                        this.$refs.noteModal.show();
                        q.close();
                    }, { id: 'cancelChanges', 'data-status': 'ok' }),

                    Noty.button('NO', 'btn btn-error', () => {
                        this.updateResult(enrolment, selectedResult);
                        q.close();
                    }),
                ],
            }).show();
        },
        updateResult(enrolment, selectedResult) {
            // actually update the result here
            if (selectedResult !== 'No Result') {
                this.isLoading = true;
                axios
                    .patch(`/api/enrolments/${enrolment.id}`, {
                        result: selectedResult,
                        note: this.updates.note,
                    })
                    .then((res) => {
                        if (['P', 'E', 'Ex'].includes(selectedResult)) {
                            // keep the elements expanded
                            this.currentRowDetails = res.data.data.competency_row_id;
                        }

                        this.$emit('refreshData');

                        const n = new Noty({
                            text: `${enrolment.code} updated!`,
                            type: 'success',
                            modal: false,
                        });
                        n.show();
                    })
                    .catch((error) => {
                        new Noty({
                            text: error.response.data.message,
                            type: 'error',
                            timeout: 1000,
                        }).show();
                    })
                    .then(() => {
                        this.isLoading = false;
                        this.updates.note = '';
                    });
            }
        },
        showElements(row) {
            row.item._showAttachments = false;
            row.toggleDetails();
        },
        showAttachments(row) {
            row.item._showAttachments = true;
            row.toggleDetails();
        },
        assessmentToolViewable(enrolment) {
            if (!enrolment.assessment_tool_linkable) {
                return false;
            }

            if (!enrolment.assessment_tool_linkable.assess_tool_main_id) {
                return false;
            }

            if (!enrolment.assessment_tool_linkable.assess_tool_id) {
                if (enrolment.assessment_tool_linkable.active == false) {
                    return false;
                }
            }

            return true;
        }
    },
};
</script>

<style>
    .text-red {
        color: #dd4b39 !important;
    }

    .text-yellow {
        color: #f39c12 !important;
    }

    .text-green {
        color: #00A65A !important;
    }

    .nowrap {
        white-space: nowrap;
    }

    .modal-xl {
        max-width: 1140px !important;
    }
</style>
